export default __webpack_public_path__ + "static/media/gf.53f0167a.jpg";